import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const WindowIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={clsx("qi-icon qi-icon-window", className)}
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M5.06462 3.03231C5.06462 4.15472 4.15472 5.06462 3.03231 5.06462C1.9099 5.06462 1 4.15472 1 3.03231C1 1.9099 1.9099 1 3.03231 1C4.15472 1 5.06462 1.9099 5.06462 3.03231Z"
        fill="currentColor"
      />
      <path
        d="M5.06462 10.0011C5.06462 11.1235 4.15472 12.0334 3.03231 12.0334C1.9099 12.0334 1 11.1235 1 10.0011C1 8.87865 1.9099 7.96875 3.03231 7.96875C4.15472 7.96875 5.06462 8.87865 5.06462 10.0011Z"
        fill="currentColor"
      />
      <path
        d="M5.06462 16.8682C5.06462 17.9907 4.15472 18.9006 3.03231 18.9006C1.9099 18.9006 1 17.9907 1 16.8682C1 15.7458 1.9099 14.8359 3.03231 14.8359C4.15472 14.8359 5.06462 15.7458 5.06462 16.8682Z"
        fill="currentColor"
      />
      <path
        d="M12.0334 3.03231C12.0334 4.15472 11.1235 5.06462 10.0011 5.06462C8.87865 5.06462 7.96875 4.15472 7.96875 3.03231C7.96875 1.9099 8.87865 1 10.0011 1C11.1235 1 12.0334 1.9099 12.0334 3.03231Z"
        fill="currentColor"
      />
      <path
        d="M12.0334 10.0011C12.0334 11.1235 11.1235 12.0334 10.0011 12.0334C8.87865 12.0334 7.96875 11.1235 7.96875 10.0011C7.96875 8.87865 8.87865 7.96875 10.0011 7.96875C11.1235 7.96875 12.0334 8.87865 12.0334 10.0011Z"
        fill="currentColor"
      />
      <path
        d="M12.0334 16.8682C12.0334 17.9907 11.1235 18.9006 10.0011 18.9006C8.87865 18.9006 7.96875 17.9907 7.96875 16.8682C7.96875 15.7458 8.87865 14.8359 10.0011 14.8359C11.1235 14.8359 12.0334 15.7458 12.0334 16.8682Z"
        fill="currentColor"
      />
      <path
        d="M18.9982 3.03231C18.9982 4.15472 18.0883 5.06462 16.9659 5.06462C15.8435 5.06462 14.9336 4.15472 14.9336 3.03231C14.9336 1.9099 15.8435 1 16.9659 1C18.0883 1 18.9982 1.9099 18.9982 3.03231Z"
        fill="currentColor"
      />
      <path
        d="M18.9982 10.0011C18.9982 11.1235 18.0883 12.0334 16.9659 12.0334C15.8435 12.0334 14.9336 11.1235 14.9336 10.0011C14.9336 8.87865 15.8435 7.96875 16.9659 7.96875C18.0883 7.96875 18.9982 8.87865 18.9982 10.0011Z"
        fill="currentColor"
      />
      <path
        d="M18.9982 16.8682C18.9982 17.9907 18.0883 18.9006 16.9659 18.9006C15.8435 18.9006 14.9336 17.9907 14.9336 16.8682C14.9336 15.7458 15.8435 14.8359 16.9659 14.8359C18.0883 14.8359 18.9982 15.7458 18.9982 16.8682Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(WindowIcon);
